export enum Locale {
    de_DE = 'de_DE',
    de_AT = 'de_AT',
    de_CH = 'de_CH',
    en_GB = 'en_GB',
    en_US = 'en_US',
    nl_NL = 'nl_NL'
}
